import React, { useState, useCallback, Fragment } from 'react'
import { Modal, Button, Row, Col, Spinner } from 'react-bootstrap'
import { banks } from '../../constants/constants'

import config from '../../config'
import CONSTANTS from '../../constants/constants'
import Cookies from 'js-cookie'
import { ORDER_ITEM_TYPE } from '../../constants/item'
import OrderItemsDataTable from '../Order/OrderItemsDataTable'
const ORDER_LABEL = CONSTANTS.orderLabels

const SelectedOrderModal = (props) => {
  const { showModalOrder, setShowModalOrder, selectedOrder } = props

  const [loading, setLoading] = useState(false)
  const [showEvidence, setShowEvidence] = useState(false)
  const [slips, setSlips] = useState([])

  const fetchSlips = useCallback(
    async (orderNo) => {
      if (slips.length > 0) return

      try {
        setLoading(true)
        const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/slip/${orderNo}/onprocess`, {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        }).then((res) => res.json())

        if (response.status.code !== 0) throw new Error(response.status.description)

        setSlips(response.data)
        setLoading(false)
      } catch (error) {
        console.error('Error while trying to fetch orders.', error)
      } finally {
        setLoading(false)
      }
    },
    [slips.length],
  )

  return !selectedOrder ? null : (
    <Modal show={showModalOrder} size="lg" scrollable style={{ padding: '2rem 0', background: 'rgba(0,0,0,0.3)' }}>
      <Modal.Header>
        คำสั่งซื้อ: #{selectedOrder.orderNo}
        <Button variant="" className="close" onClick={() => setShowModalOrder(false)}>
          <span>&times;</span>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td className="py-2">ชื่อ</td>
              <td>
                {selectedOrder.user.firstName} {selectedOrder.user.lastName}
              </td>
            </tr>
            <tr>
              <td className="py-2">หมายเลขสมาชิก</td>
              <td>{selectedOrder.user.userNo}</td>
            </tr>
            <tr>
              <td className="py-2">วันที่สร้างคำสั่งซื้อ</td>
              <td>{new Date(selectedOrder.createdAt).toLocaleString('TH-th')}</td>
            </tr>
            <tr>
              <td className="py-2">วันที่คำสั่งซื้อถูกอนุมัติ</td>
              <td>{selectedOrder.approvedAt ? new Date(selectedOrder.approvedAt).toLocaleString('TH-th') : '-'}</td>
            </tr>
            <tr>
              <td className="py-2">เบอร์โทรศัพท์</td>
              <td>{selectedOrder.user.phoneNo}</td>
            </tr>
            <tr>
              <td className="py-2">บัญชีลูกค้า</td>
              <td>
                {selectedOrder.user.bankName && (
                  <span>
                    {banks[selectedOrder.user.bankName]} {selectedOrder.user.bankNo}
                  </span>
                )}
              </td>
            </tr>
            <tr>
              <td className="py-2">สถานะ</td>
              <td>{ORDER_LABEL[selectedOrder.status.toLowerCase()]}</td>
            </tr>
            <tr>
              <td>ราคารวม</td>
              <td>
                <h3 style={{ color: 'red' }}>{selectedOrder.totalPrice}</h3>
              </td>
            </tr>
          </tbody>
        </table>
        <div span={24} className="py-4 text-center">
          <Button
            variant="primary"
            onClick={() => {
              setShowEvidence((prev) => !prev)
              fetchSlips(selectedOrder.orderNo)
            }}
          >
            {showEvidence ? 'ซ่อน' : 'แสดง'}
            หลักฐานการโอน
          </Button>
        </div>
        {showEvidence &&
          (loading ? (
            <div style={{ textAlign: 'center', paddingBottom: '12px' }}>
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            slips.length > 0 && (
              <div style={{ paddingBottom: '16px' }}>
                <h3>หลักฐานการโอนเงิน</h3>
                <Row>
                  {slips.length > 0 ? (
                    slips.map((slip) => (
                      <Col>
                        <div className="row">
                          <div
                            className="col-5"
                            style={{
                              display: 'flex',
                            }}
                          >
                            {slip.imageUrl !== '' ? (
                              <img
                                src={`${slip.imageUrl}`}
                                style={{
                                  maxWidth: '360px',
                                  maxHeight: '600px',
                                }}
                                alt="slip"
                              />
                            ) : (
                              'ไม่พบสลิป'
                            )}
                          </div>
                          <div className="col-7">
                            <h4>สถานะระบบตรวจสอบสลิปอัตโนมัติ </h4>
                            <>
                              <hr />
                              <p>
                                <b>สถานะ</b>: {`${slip.transaction[0].status}`}
                              </p>
                              <p>
                                <b>จำนวนเงินที่ระบบอ่านได้</b>: {`${slip.transaction[0].amount}`} บาท
                              </p>
                              <p>
                                <b>รายละเอียด</b>: {`${slip.transaction[0].remark}`}
                              </p>
                              <p>
                                <b>อัปโหลดเมื่อเวลา</b>: {new Date(slip.createdAt).toLocaleString('TH-th')} น.
                              </p>
                              <p>
                                <b>ตรวจสอบเมื่อเวลา</b>:{' '}
                                {new Date(slip.transaction[0].createdAt).toLocaleString('TH-th')} น.
                              </p>
                              {slip.transaction[0].actionTransaction.length > 0 ? (
                                <>
                                  <hr />
                                  <h4>ประวัติการแจ้งเตือน</h4>
                                  <hr />
                                  {slip.transaction[0].actionTransaction.map((element) => (
                                    <p>
                                      [{element.from}]: {element.action} (
                                      {new Date(element.createdAt).toLocaleString('TH-th')})
                                    </p>
                                  ))}
                                </>
                              ) : null}
                              {slip.transaction[0].solvedBy ? (
                                <div>
                                  <hr />
                                  <h4>ข้อมูลรายละเอียดการจัดสลิป Slip โดย Admin</h4>
                                  <hr />
                                  <p>
                                    <b>ชื่อผู้ตรวจสอบ</b>: {slip.transaction[0].solvedBy.userName}
                                  </p>
                                  <p>
                                    <b>ผลการตรวจสอบ</b>: {slip.transaction[0].solvedBy.detail}
                                  </p>
                                  <p>
                                    <b>ตรวจสอบเมื่อเวลา</b>:{' '}
                                    {new Date(slip.transaction[0].solvedBy.createdAt).toLocaleString('TH-th')} น.
                                  </p>
                                </div>
                              ) : null}
                            </>
                          </div>
                        </div>
                      </Col>
                    ))
                  ) : (
                    <Col>
                      <div
                        style={{
                          marginBottom: '8px',
                          textAlign: 'center',
                          color: 'red',
                        }}
                      >
                        ไม่พบสลิปสำหรับคำสั่งซื้อ #{selectedOrder.refNo}
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            )
          ))}
        <Row>
          <Col>
            <div className="border-bottom mt-4 mb-2">
              <h3>
                รายละเอียดการสั่งซื้อ{' '}
                {selectedOrder.items[0].type === ORDER_ITEM_TYPE.LOTTERY ? (
                  <span style={{ fontSize: '20px' }} className="text-info">
                    (ลอตเตอรี่)
                  </span>
                ) : (
                  <span style={{ fontSize: '20px' }} className="text-danger">
                    (กล่องสุ่ม)
                  </span>
                )}
              </h3>
            </div>
          </Col>
        </Row>
        <Row>
          <OrderItemsDataTable order={selectedOrder} orderType={selectedOrder.items[0].type} />
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default SelectedOrderModal
